import styles from "./ConversationDetail.module.less";
import { useContext } from "react";
import { CopilotMessageContext } from "~/providers/CopilotMessageProvider";
import ConversationHeader from "./components/conversationHeader/ConversationHeader";
import ConversationMessages from "./components/conversationMessages/ConversationMessages";

function ConversationDetail() {
  const { isConversationListExpanded, selectedConversation } = useContext(
    CopilotMessageContext,
  );

  return (
    <div
      className={`${styles.ConversationDetail} ${
        isConversationListExpanded ? "" : styles.expanded
      }`}
    >
      {selectedConversation && (
        <>
          <ConversationHeader />
          <ConversationMessages key={selectedConversation.id} />
        </>
      )}
    </div>
  );
}

export default ConversationDetail;
